export const LANGUAGE_OPTIONS = [
  'Deutsch',
  'Englisch',
  'Spanisch',
  'Französisch',
  'Italienisch',
  'Portugiesisch',
  'Russisch',
  'Chinesisch',
  'Japanisch',
  'Arabisch'
];

export const LANGUAGE_LEVEL_OPTIONS = [
  { key: 'A1', value: 'cvBuilderPage.languageSkills.form.level.A1' },
  { key: 'A2', value: 'cvBuilderPage.languageSkills.form.level.A2' },
  { key: 'B1', value: 'cvBuilderPage.languageSkills.form.level.B1' },
  { key: 'B2', value: 'cvBuilderPage.languageSkills.form.level.B2' },
  { key: 'C1', value: 'cvBuilderPage.languageSkills.form.level.C1' },
  { key: 'C2', value: 'cvBuilderPage.languageSkills.form.level.C2' }
];
